import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { isAndroid } from '@/utils/platformDetection'

const appleWalletStepKeys = [
  'screens:kemCard.walletInstructions.tapTheButtonBelow',
  'screens:kemCard.walletInstructions.tapPlusOnAppleWallet',
  'screens:kemCard.walletInstructions.selectDebitOrCreditCard',
  'screens:kemCard.walletInstructions.enterCardInfos',
  'screens:kemCard.walletInstructions.tapNextToFinish',
]

const googleWalletStepKeys = [
  'screens:kemCard.walletInstructions.tapTheButtonBelow',
  'screens:kemCard.walletInstructions.tapPlusOnGoogleWallet',
  'screens:kemCard.walletInstructions.selectPaymentCardGoogleWallet',
  'screens:kemCard.walletInstructions.tapNewCreditOrDebitCard',
  'screens:kemCard.walletInstructions.enterCardInfos',
  'screens:kemCard.walletInstructions.tapSaveAndContinue',
  'screens:kemCard.walletInstructions.chooseAnIdVerificationMethodToFinish',
]

export const WalletInstructionsSteps: React.FC<{
  platform: 'apple' | 'google'
}> = ({ platform }) => {
  const { t } = useTranslation()

  const steps =
    platform === 'google' ? googleWalletStepKeys : appleWalletStepKeys

  return (
    <BaseView px={8} gap={24}>
      <BaseText
        fontSize={28}
        fontFamily="semibold"
        color="label.default"
        textAlign="center"
      >
        {t('screens:kemCard.walletInstructions.howAddYourCard')}
      </BaseText>

      <BaseView gap={4}>
        {steps.map((step, index) => (
          <BaseView
            key={index}
            style={{ flexDirection: 'row', alignItems: 'center' }}
          >
            <BaseText fontSize={14} fontFamily="regular" color="label.default">
              {index + 1}. {t(step)}
            </BaseText>
          </BaseView>
        ))}
      </BaseView>
    </BaseView>
  )
}
